module.exports = __webpack_public_path__ + "static/media/2_1.e5bf2e0a.jpg";